module.exports = __webpack_public_path__ + "img/007-donation-1.54f11a2c.svg";